import CountdownTimer from "components/count-down"
import Modal from "global/Modal/Modal"
import SimpleButton from "global/SimpleButton/SimpleButton"
import { useState } from "react"
import { usePayment } from "./usePayment"

const PosPaymentModal = ({ isOpen, setIsOpen, paymentData, refreshTable }) => {
  const {
    handleClick,
    setIsLoading,
    isLoading,
    isLoadingPos,
    setIsLoadingPos,
    time,
  } = usePayment(paymentData, refreshTable, setIsOpen, isOpen)
  const [startCountDown, setStartCountDown] = useState(false)

  //   useEffect(() => {
  //     !isOpen && setIsLoading(false)
  //     setIsLoadingPos(false)
  //   }, [isOpen])

  return (
    <Modal visible={isOpen} setVisible={setIsOpen} title='پراخت با کارتخوان '>
      <div className='text-base flex justify-between w-96'>
        <span>مبلغ پرداختی: </span>
        <span className='font-semibold'>
          {paymentData.amount.toLocaleString()}
          ریال
        </span>
      </div>

      <div className='btnForm mt-8'>
        <SimpleButton
          handelClick={() => setIsOpen({ ...isOpen, posModal: false })}
          text='لغو'
          className='text-tomato'
        />
        <SimpleButton
          type='submit'
          handelClick={() => {
            handleClick()
            setStartCountDown(true)
          }}
          text=' پرداخت'
          className='full-tomato-btn'
          disabled={isLoadingPos || isLoading}
          loading={isLoadingPos}
        />
      </div>

      {startCountDown && <CountdownTimer initialTime={time} />}
    </Modal>
  )
}

export default PosPaymentModal
